
import BRadioGroup from 'JS/components/blain-form/BRadioGroup.vue';
import Icon from 'JS/components/Icon.vue';
import { defineComponent, PropType, watch } from 'vue';
import { useListSlider } from 'JS/composables/list-slider';
import { useViewportWidth } from 'JS/composables/breakpoint';

export default defineComponent({
	components: {
		BRadioGroup,
		Icon,
	},
	// match Vue 3
	model: {
		prop: 'modelValue',
		event: 'update:modelValue',
	},
	props: {
		days: {
			type: Array as PropType<{ date: Date, hasTimeSlots: boolean }[]>,
			required: true,
		},
		modelValue: {
			type: Date,
		}
	},
	setup (props, { emit }) {
		const { viewport, next, previous, slider } = useListSlider();

		const viewportWidth = useViewportWidth();
		watch(() => [viewportWidth.value, props.days], () => slider.value?.reset());

		watch(() => props.modelValue, selectedDate => {
			const index = props.days.findIndex(({ date }) => date === selectedDate);
			slider.value.slideIndexIntoView(index);
		});

		return {
			viewport,
			next,
			previous,
			slider,
			update(date: Date) {
				emit('update:modelValue', date);
			},
		};
	}
});
